import { render, staticRenderFns } from "./EligibilityQuestion.vue?vue&type=template&id=36ec6ee1&"
import script from "./EligibilityQuestion.vue?vue&type=script&lang=js&"
export * from "./EligibilityQuestion.vue?vue&type=script&lang=js&"
import style0 from "./EligibilityQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports